import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store";
import { addRoom, deleteRoomServicee, fetchRoomsByStays, updateRoom } from "../../../features/admin/roomSlice";
import { useTranslation } from "react-i18next";
import { Room } from "../../../types";
import { fetchServices } from "../../../features/admin/serviceSlice";
import Cookies from "js-cookie";
import { roomTypes } from "../../../constants/data";
import i18n from "../../../i18n";

const RoomForm = ({ placeId, setShow, existRoom }: { placeId: any, setShow: any, existRoom?: Room }) => {
    const dispatch = useDispatch<AppDispatch>();
    const { services } = useSelector((state: RootState) => state.serviceSlice)
    const userId = Cookies.get('userId');
    const { t } = useTranslation();
    const [room, setRoom] = useState({
        roomNumber: existRoom?.roomNumber || "",
        type: existRoom?.type || "",
        pricePerNight: existRoom?.pricePerNight?.toString() || "",
        amenities: [] as number[],
        hasOffer: existRoom?.hasOffer || false,
        image: null as File | null,
    });
    const [imagePreview, setImagePreview] = useState<string>(
        existRoom?.image || ''
    );
    useEffect(() => {

        dispatch(fetchServices());
    }, [dispatch]);
    useEffect(() => {
        if (existRoom && existRoom.amenities) {
            const amenityIds = existRoom.amenities.map((a) => a.id);
            setRoom((prev) => ({
                ...prev,
                amenities: amenityIds,
            }));
        }
    }, [existRoom]);
    const handleCheckboxChange = () => {
        setRoom((prev) => ({ ...prev, hasOffer: !prev.hasOffer }));
    };

    const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files[0]) {
            const file = e.target.files[0];
            setRoom({ ...room, image: file });
            setImagePreview(URL.createObjectURL(file));
        }
    };
    const handleChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
    ) => {
        const { name, value } = e.target;
        setRoom((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmitRoom = async () => {
        if (
            room.roomNumber.trim() === "" ||
            room.type.trim() === "" ||
            room.pricePerNight.trim() === ""
        ) {
            alert(t("fill-all-fields"));
            return;
        }

        const formData = new FormData();
        formData.append("roomNumber", room.roomNumber);
        formData.append("type", room.type);
        formData.append("pricePerNight", room.pricePerNight);
        formData.append("hasOffer", room.hasOffer.toString());
        formData.append("placeId", placeId);
        room.amenities.forEach((id) => formData.append("amenities", id.toString()));
        if (room.image) {
            formData.append("image", room.image);
        }

        try {
            if (existRoom) {
                await dispatch(updateRoom({ id: existRoom.id, data: formData })).unwrap();
            } else {
                await dispatch(addRoom(formData)).unwrap();
            }

            setRoom({
                roomNumber: "",
                type: "",
                pricePerNight: "",
                hasOffer: false,
                amenities: [],
                image: null
            });

            userId && await dispatch(fetchRoomsByStays({ stayId: parseInt(placeId), userId }))
            setShow(false);
        } catch (error) {
            console.error("Failed to submit room:", error);
        }
    };


    return (
        <div className=" fixed inset-0 bg-black bg-opacity-30 flex justify-center  p-5 z-50">
            <div className="bg-white p-6 rounded-xl overflow-y-scroll overscroll-none w-full max-w-xl shadow-lg space-y-4">
                <h3 className="text-lg font-semibold">{t("add-room")}</h3>
                <div className="grid grid-cols-1  gap-4">
                    <div className="w-full">
                        <label htmlFor="image-upload" className="block cursor-pointer">
                            <div className="w-full h-40 border border-dashed rounded flex items-center justify-center bg-gray-50 hover:bg-gray-100 transition">
                                {imagePreview ? (
                                    <img
                                        src={imagePreview}
                                        alt="Preview"
                                        className="w-full h-full object-cover rounded"
                                    />
                                ) : (
                                    <span className="text-gray-500">{t("click_to_select")}</span>
                                )}
                            </div>
                        </label>

                        <input
                            id="image-upload"
                            type="file"
                            name="image"
                            accept="image/*"
                            onChange={handleImageChange}
                            className="hidden"
                        />
                    </div>
                    <div>
                        <label className="block mb-1 text-gray-600">{t("room-number")}</label>
                        <input
                            type="text"
                            name="roomNumber"
                            value={room.roomNumber}
                            onChange={handleChange}
                            className="input-field"
                        />
                    </div>
                    <div>
                        <label className="block mb-1 text-gray-600">{t("room-type")}</label>
                        <select
                            name="type"
                            value={room.type}
                            onChange={handleChange}
                            className="input-field"
                        >
                            <option value=""></option>
                            {roomTypes.map((room, index) => (
                                <option key={index} value={room.titleEn}>
                                    {i18n.language === 'ar' ? room.typeAr : room.titleEn}
                                    
                                </option>
                            ))}
                        </select>
                    </div>
                    <div>
                        <label className="block mb-1 text-gray-600">{t("price-per-night")}</label>
                        <input
                            type="number"
                            name="pricePerNight"
                            value={room.pricePerNight}
                            onChange={handleChange}
                            className="input-field"
                        />
                    </div>
                    <div className="flex items-center gap-2">
                        <button
                            type="button"
                            onClick={handleCheckboxChange}
                            className={`w-5 h-5 rounded  border  flex items-center justify-center transition  ${room.hasOffer ? "bg-secondry" : "bg-white"}`}
                        >
                            {room.hasOffer && (
                                <svg className="w-5 h-5 text-white" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
                                    <path d="M5 13l4 4L19 7" />
                                </svg>
                            )}
                        </button>
                        <label className="text-gray-700 text-sm cursor-pointer" onClick={handleCheckboxChange}>
                            {t("has-offer")}
                        </label>
                    </div>
                    <div className="flex flex-wrap  gap-4">
                        {services.map((item) => {
                            const isSelected = room.amenities.includes(item.id);

                            const handleAmenityToggle = () => {
                                if (isSelected) {
                                    if (existRoom) {
                                        dispatch(deleteRoomServicee({ roomId: Number(existRoom.id), serviceId: item.id }));
                                    }

                                    setRoom((prev) => ({
                                        ...prev,
                                        amenities: prev.amenities.filter((id) => id !== item.id),
                                    }));
                                } else {
                                    setRoom((prev) => ({
                                        ...prev,
                                        amenities: [...prev.amenities, item.id],
                                    }));
                                }
                            };

                            return (
                                <div
                                    key={item.id}
                                    onClick={handleAmenityToggle}
                                    className={`cursor-pointer flex items-center gap-2 p-2 rounded-lg border transition hover:shadow-md ${isSelected ? 'bg-primary text-white border-primary shadow-lg' : 'bg-white'
                                        }`}
                                >
                                    <div className='w-6 h-6'>
                                        <img
                                            src={item.image}
                                            alt={item.title}
                                            className="w-full object-cover rounded-md mb-2"
                                        />
                                    </div>
                                    <p className="text-center text-nowrap text-sm font-medium">{item.title}</p>
                                </div>
                            );
                        })}
                    </div>
                </div>

                <div className="flex justify-between pt-4">
                    <button onClick={() => setShow(false)} className="px-4 py-2 bg-gray-300 rounded">
                        {t("cancel")}
                    </button>
                    <button onClick={handleSubmitRoom} className="bg-primary text-white text-sm px-6 py-2 rounded">
                        {existRoom ? t("update-room") : t("add-room")}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default RoomForm;
